import React from 'react';
import Barcode from '../Barcode';
import Modal from '../Modal';

const ModalBarcode = ({ barcode, nid, onClose }: any) => {
  return (
    <Modal open={true} onClose={onClose} title='Imprimir código de barras'>
      <Barcode barcode={barcode} nid={nid} />
    </Modal>
  );
};

export default ModalBarcode;
